import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import quotes from "@/assets/quotes";
import { useQuoteStore } from "@/stores/root/quote";

const activeClass = "active";
const inActiveClass = "inactive";
const defaultClass = "steps";

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonStepMenu',
  props: {
  step: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const quoteStore = useQuoteStore();
const props = __props;

const title = computed(() => {
  const newQuote = quotes[props.step];
  return newQuote.wizardTitle;
});

const stepClass = computed(() => {
  if (props.step == quoteStore.currentStep) {
    return `${activeClass} ${defaultClass}`;
  } else if (
    quotes[props.step]?.index > quotes[quoteStore.currentStep]?.index
  ) {
    return `${inActiveClass} ${defaultClass}`;
  } else {
    return defaultClass;
  }
});

/**
 * Go directly to a specific page.
 */
function goToPage() {
  quoteStore.done == false
    ? quoteStore.setQuoteStep(props.step)
    : (window.location.href = "/renters");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(stepClass.value),
    onClick: goToPage
  }, _toDisplayString(title.value), 3))
}
}

})